var _excluded = ["anchorRef", "children", "className", "onClose", "open", "placement", "pointer", "style", "removeSpacer"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { forwardRef, useContext, useEffect, useRef, useState } from "react";
import ReactDOM from "react-dom";
import PropTypes from "prop-types";
import AAppContext from "../AApp/AAppContext";
import { useCombinedRefs } from "../../utils/hooks";
import { getRoundedBoundedClientRect } from "../../utils/helpers";
import "./AMenuBase.scss";
var calculateMenuPosition = function calculateMenuPosition(combinedRef, appRef, wrapRef, anchorRef, placement, setMenuLeft, setMenuTop, setInvisible) {
  var _appRef$current$offse, _appRef$current$offse2;
  var removeSpacer = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : false;
  if (!combinedRef.current) return;
  var appCoords = getRoundedBoundedClientRect(appRef.current);
  var wrapCoords = getRoundedBoundedClientRect(wrapRef.current);
  var anchorCoords = getRoundedBoundedClientRect(anchorRef.current);
  var menuCoords = getRoundedBoundedClientRect(combinedRef.current);
  var magneticSpacer = removeSpacer ? 0 : 4;
  var baseLeft = 0,
    baseTop = 0;
  switch (placement) {
    case "top":
      {
        baseLeft = (anchorCoords.left + anchorCoords.right) / 2 - menuCoords.width / 2 - wrapCoords.left;
        baseTop = anchorCoords.top - menuCoords.height - wrapCoords.top;
        break;
      }
    case "top-right":
      {
        baseLeft = anchorCoords.right - menuCoords.width - wrapCoords.left;
        baseTop = anchorCoords.top - menuCoords.height - wrapCoords.top;
        break;
      }
    case "right-top":
      {
        baseLeft = anchorCoords.right - wrapCoords.left;
        baseTop = anchorCoords.top - wrapCoords.top;
        break;
      }
    case "right":
      {
        baseLeft = anchorCoords.right - wrapCoords.left;
        baseTop = (anchorCoords.top + anchorCoords.bottom) / 2 - menuCoords.height / 2 - wrapCoords.top;
        break;
      }
    case "right-bottom":
      {
        baseLeft = anchorCoords.right - wrapCoords.left;
        baseTop = anchorCoords.bottom - menuCoords.height - wrapCoords.top;
        break;
      }
    case "bottom-right":
      {
        baseLeft = anchorCoords.right - menuCoords.width - wrapCoords.left;
        baseTop = anchorCoords.bottom - wrapCoords.top + magneticSpacer;
        break;
      }
    case "bottom":
      {
        baseLeft = (anchorCoords.left + anchorCoords.right) / 2 - menuCoords.width / 2 - wrapCoords.left;
        baseTop = anchorCoords.bottom - wrapCoords.top + magneticSpacer;
        break;
      }
    case "bottom-left":
      {
        baseLeft = anchorCoords.left - wrapCoords.left;
        baseTop = anchorCoords.bottom - wrapCoords.top + magneticSpacer;
        break;
      }
    case "left-bottom":
      {
        baseLeft = anchorCoords.left - menuCoords.width - wrapCoords.left;
        baseTop = anchorCoords.bottom - menuCoords.height - wrapCoords.top;
        break;
      }
    case "left":
      {
        baseLeft = anchorCoords.left - menuCoords.width - wrapCoords.left;
        baseTop = (anchorCoords.top + anchorCoords.bottom) / 2 - menuCoords.height / 2 - wrapCoords.top;
        break;
      }
    case "left-top":
      {
        baseLeft = anchorCoords.left - menuCoords.width - wrapCoords.left;
        baseTop = anchorCoords.top - wrapCoords.top;
        break;
      }
    case "top-left":
      {
        baseLeft = anchorCoords.left - wrapCoords.left;
        baseTop = anchorCoords.top - menuCoords.height - wrapCoords.top;
        break;
      }
  }
  var marginLeft = parseInt(window.getComputedStyle(combinedRef.current).marginLeft);
  var marginTop = parseInt(window.getComputedStyle(combinedRef.current).marginTop);
  var xOffset = (_appRef$current$offse = appRef.current.offsetParent) !== null && _appRef$current$offse !== void 0 && _appRef$current$offse.isSameNode(document.body) ? window.pageXOffset : wrapCoords.left - appCoords.scrollLeft;
  var yOffset = (_appRef$current$offse2 = appRef.current.offsetParent) !== null && _appRef$current$offse2 !== void 0 && _appRef$current$offse2.isSameNode(document.body) ? window.pageYOffset : wrapCoords.top - appCoords.scrollTop;
  var pageWidth = document.documentElement.clientWidth + xOffset - wrapRef.current.offsetLeft;
  var pageHeight = document.documentElement.clientHeight + yOffset - wrapRef.current.offsetTop;

  // Edge detection: max x
  if (baseLeft + menuCoords.width + marginLeft > pageWidth) {
    baseLeft = pageWidth - menuCoords.width - marginLeft;
  }

  // Edge detection: min x
  if (baseLeft + marginLeft < xOffset) {
    baseLeft = xOffset - marginLeft;
  }

  // Edge detection: max y
  if (baseTop + menuCoords.height + marginTop > pageHeight) {
    baseTop = pageHeight - menuCoords.height - marginTop;
  }

  // Edge detection: min y
  else if (baseTop < yOffset) {
    baseTop = yOffset - marginTop;
  }
  setMenuLeft(Math.round(baseLeft));
  setMenuTop(Math.round(baseTop));
  setInvisible(false);
};
var calculatePointerPosition = function calculatePointerPosition(combinedRef, anchorRef, pointer, placement, setPointerLeft, setPointerTop) {
  if (!combinedRef.current) return;
  var anchorCoords = getRoundedBoundedClientRect(anchorRef.current);
  var menuCoords = getRoundedBoundedClientRect(combinedRef.current);

  // Pointer
  if (!pointer) return;
  switch (placement) {
    case "top":
    case "top-left":
    case "top-right":
    case "bottom":
    case "bottom-left":
    case "bottom-right":
      {
        var left = menuCoords.left + menuCoords.width / 2;
        if (menuCoords.width > anchorCoords.width) {
          left = anchorCoords.left + anchorCoords.width / 2;
        }
        setPointerLeft(left - menuCoords.left - 6);
        setPointerTop(null);
        break;
      }
    case "right":
    case "right-bottom":
    case "right-top":
    case "left":
    case "left-bottom":
    case "left-top":
      {
        var top = menuCoords.top + menuCoords.height / 2;
        if (menuCoords.height > anchorCoords.height) {
          top = anchorCoords.top + anchorCoords.height / 2;
        }
        setPointerLeft(null);
        setPointerTop(top - menuCoords.top - 6);
        break;
      }
  }
};
var AMenuBase = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var anchorRef = _ref.anchorRef,
    children = _ref.children,
    propsClassName = _ref.className,
    onClose = _ref.onClose,
    open = _ref.open,
    _ref$placement = _ref.placement,
    placement = _ref$placement === void 0 ? "bottom-left" : _ref$placement,
    pointer = _ref.pointer,
    propsStyle = _ref.style,
    _ref$removeSpacer = _ref.removeSpacer,
    removeSpacer = _ref$removeSpacer === void 0 ? false : _ref$removeSpacer,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useContext = useContext(AAppContext),
    appRef = _useContext.appRef,
    wrapRef = _useContext.wrapRef;
  var menuRef = useRef(null);
  var combinedRef = useCombinedRefs(ref, menuRef);
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    menuLeft = _useState2[0],
    setMenuLeft = _useState2[1];
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    menuTop = _useState4[0],
    setMenuTop = _useState4[1];
  var _useState5 = useState(true),
    _useState6 = _slicedToArray(_useState5, 2),
    invisible = _useState6[0],
    setInvisible = _useState6[1];
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    pointerLeft = _useState8[0],
    setPointerLeft = _useState8[1];
  var _useState9 = useState(null),
    _useState10 = _slicedToArray(_useState9, 2),
    pointerTop = _useState10[0],
    setPointerTop = _useState10[1];
  useEffect(function () {
    calculateMenuPosition(combinedRef, appRef, wrapRef, anchorRef, placement, setMenuLeft, setMenuTop, setInvisible, removeSpacer);
  }, [open, anchorRef, combinedRef, placement, appRef, wrapRef, removeSpacer]);
  useEffect(function () {
    calculatePointerPosition(combinedRef, anchorRef, pointer, placement, setPointerLeft, setPointerTop);
  }, [anchorRef, combinedRef, placement, pointer, menuLeft, menuTop]);
  useEffect(function () {
    var screenChangeHandler = function screenChangeHandler() {
      calculateMenuPosition(combinedRef, appRef, wrapRef, anchorRef, placement, setMenuLeft, setMenuTop, setInvisible, removeSpacer);
    };
    window.addEventListener("resize", screenChangeHandler);
    window.addEventListener("fullscreenchange", screenChangeHandler);
    return function () {
      window.removeEventListener("resize", screenChangeHandler);
      window.removeEventListener("fullscreenchange", screenChangeHandler);
    };
  }, [anchorRef, combinedRef, placement, appRef, wrapRef, removeSpacer]);
  useEffect(function () {
    var screenChangeHandler = function screenChangeHandler() {
      calculateMenuPosition(combinedRef, appRef, wrapRef, anchorRef, placement, setMenuLeft, setMenuTop, setInvisible, removeSpacer);
    };
    window.addEventListener("resize", screenChangeHandler);
    return function () {
      window.removeEventListener("resize", screenChangeHandler);
    };
  }, [anchorRef, combinedRef, placement, appRef, wrapRef, removeSpacer]);
  useEffect(function () {
    var clickOutsideHandler = function clickOutsideHandler(e) {
      if (anchorRef.current && combinedRef.current && open && !anchorRef.current.contains(e.target) && !combinedRef.current.contains(e.target)) {
        onClose && onClose(e);
      }
    };
    window.addEventListener("mousedown", clickOutsideHandler);
    return function () {
      window.removeEventListener("mousedown", clickOutsideHandler);
    };
  }, [anchorRef, combinedRef, onClose, open]);
  var className = "a-menu-base a-menu-base--".concat(placement);
  if (!invisible && open) {
    className += " a-menu-base--active";
  }
  if (propsClassName) {
    className += " ".concat(propsClassName);
  }
  var style = {
    left: menuLeft,
    top: menuTop
  };
  if (propsStyle) {
    style = _objectSpread(_objectSpread({}, propsStyle), style);
  }
  var pointerStyle = {};
  if (pointerLeft !== null) {
    pointerStyle.left = pointerLeft;
  }
  if (pointerTop !== null) {
    pointerStyle.top = pointerTop;
  }
  return open && appRef.current && /*#__PURE__*/ReactDOM.createPortal( /*#__PURE__*/React.createElement("div", _extends({
    "data-ignore-outside-click": true
  }, rest, {
    ref: combinedRef,
    className: className,
    style: style
  }), pointer && /*#__PURE__*/React.createElement("div", {
    className: "a-menu-base__pointer",
    style: pointerStyle
  }), children), appRef.current) || null;
});
AMenuBase.propTypes = {
  /**
   * The reference to the menu anchor.
   */
  anchorRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.any
  })]).isRequired,
  /**
   * Handles the request to close the menu.
   */
  onClose: PropTypes.func,
  /**
   * Toggles the `open` state.
   */
  open: PropTypes.bool,
  /**
   * The placement of the menu.
   */
  placement: PropTypes.oneOf(["top", "top-right", "right-top", "right", "right-bottom", "bottom-right", "bottom", "bottom-left", "left-bottom", "left", "left-top", "top-left"]),
  /**
   * Toggles the menu pointer.
   */
  pointer: PropTypes.bool,
  /**
   * Option to remove the space between the anchor and the menu for bottom placement
   */
  removeSpacer: PropTypes.bool
};
AMenuBase.displayName = "AMenuBase";
export default AMenuBase;